const activeClassName = 'active';

export function updateIndicator(navItems, sectionName) {
    navItems.children().removeClass(activeClassName);
    navItems.find('[data-indicator="' + sectionName + '"]').addClass(activeClassName);
}


//////////////////
// WEBPACK FOOTER
// ./src/js/section-indicator.js
// module id = JqLv
// module chunks = 0